import { render, staticRenderFns } from "./ThgZip.vue?vue&type=template&id=e31cde60"
import script from "./ThgZip.vue?vue&type=script&lang=ts"
export * from "./ThgZip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports